<template>
	<div @mouseleave="headerMouseLeave">
		<div class="header">
			<div class="logo">
				<el-image :src="detail_logo.icon" :title="detail_logo.title" style="height: 60px; cursor: pointer;" @click="toUrl('/')" fit="contain">
					<div slot="error" class="image-slot">
					</div>
				</el-image>
			</div>
			<div class="menu">
				<div ref="menuref9" :class="menu_node_class[0]" @mouseenter="headerMouseLeave(); focusMenuEnter();" @mouseleave="handleMenuCur()" @click="toUrl('/')" style="width: 50px; margin-right: 7px">首页</div>
				<div ref="menuref0" :class="menu_node_class[1]" @mouseenter="menuEnter(0)" @mouseleave="handleMenuCur()" @click="toUrl('/list_biaogan')">标杆企业</div>
				<div ref="menuref1" :class="menu_node_class[2]" @mouseenter="menuEnter(1)" @mouseleave="handleMenuCur()" @click="toUrl('/list_wenda')">问询答复</div>
				<div ref="menuref2" :class="menu_node_class[3]" @mouseenter="menuEnter(2)" @mouseleave="handleMenuCur()" @click="toUrl('/statis')">数据分析</div>
				<div ref="menuref3" :class="menu_node_class[4]" @mouseenter="menuEnter(3)" @mouseleave="handleMenuCur()" @click="toUrl('/daohang')">成长导航</div>
				<div ref="menuref4" :class="menu_node_class[5]" @mouseenter="menuEnter(4)" @mouseleave="handleMenuCur()" @click="toUrl('/zhichan')">知识产权</div>
				<div ref="menuref5" :class="menu_node_class[6]" @mouseenter="menuEnter(5)" @mouseleave="handleMenuCur()" @click="toUrl('/fengxian')">风险管控</div>
			</div>
			
			<div class="logreg">
				
				<div class="jianyi" v-show="is_login == true" @click="doExit">退出</div>
				<div class="jianyi" v-show="is_login == true" @click="toUrl('/user_uinfo')">控制台</div>
				
				<div class="register" v-show="is_login == false" @click="toUrl('/login')">注册</div>
				<div class="login" v-show="is_login == false" @click="toUrl('/login')">登陆</div>
				
				<!-- <div class="jianyi" style="width: 100px; margin-top: -1px">
					<el-link type="primary"  @click="toUrl('/search')">强企搜搜</el-link>
				</div> -->
			</div>
		</div>
		
		<!-- 标杆企业 -->
		<div class="drop_menu" v-show="is_show_menu[0]" @mouseleave="menuLeave(0)">
			<el-row>
				<el-col :span="6">
					<div class="drop_menu_left">
						<div class="drop_menu_left_title" v-for="(item, index) in list_bgqy_menu" :key="index" @click="toUrl(item.url)">
							<span :style="{color: menu0_sub_color[index], fontWeight: menu0_sub_fontWeight[index]}" @mouseenter="menu0SubEnter(index)">
								{{item.title}}
							</span>
						</div>
					</div>
				</el-col>
				<el-col :span="18">
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[0]">
						
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_0" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[0]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[1]">
						
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_1" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[1]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[2]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_2" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[2]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[3]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_3" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[3]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[4]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_4" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[4]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[5]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_5" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[5]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[6]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_6" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[6]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[7]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_7" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[7]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[8]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_8" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[8]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[9]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_9" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[9]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[10]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_10" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[10]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[11]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_11" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[11]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[12]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_12" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[12]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu0_sub[13]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_bgqy_menu_13" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.bgqy[13]}}
						</div>
					</div>
					
					
				</el-col>
			</el-row>
		</div>
		
		<!-- 问询答复 -->
		<div class="drop_menu" v-show="is_show_menu[1]" @mouseleave="menuLeave(1)">
			<el-row>
				<el-col :span="6">
					<div class="drop_menu_left">
						<div class="drop_menu_left_title" v-for="(item, index) in list_wxdf_menu" :key="index" @click="toUrl(item.url)">
							<span :style="{color: menu1_sub_color[index], fontWeight: menu1_sub_fontWeight[index]}" @mouseenter="menu1SubEnter(index)">
								{{item.title}}
							</span>
						</div>
					</div>
				</el-col>
				<el-col :span="18">
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[0]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_0" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[0]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[1]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_1" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[1]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[2]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_2" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[2]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[3]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_3" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[3]}}
						</div>
					</div>
				
					<div class="drop_menu_right" v-show="is_show_menu1_sub[4]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_4" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[4]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[5]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_5" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[5]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[6]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_6" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[6]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[7]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_7" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[7]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[8]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_8" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[8]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[9]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_9" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[9]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[10]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_10" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[10]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[11]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_11" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[11]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[12]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_12" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[12]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu1_sub[13]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_wxdf_menu_13" :key="index">
									<el-tooltip placement="left" effect="dark" :enterable="false">
										<div slot="content" v-html="item.summary"></div>
										<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
											{{item.title}}
										</div>
									</el-tooltip>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.wxdf[13]}}
						</div>
					</div>
					
				
				</el-col>
			</el-row>
		</div>
		
		<!-- 数据分析 -->
		<div class="drop_menu" v-show="is_show_menu[2]" @mouseleave="menuLeave(2)">
			<el-row>
				<el-col :span="6">
					<div class="drop_menu_left">
						<div class="drop_menu_left_title" v-for="(item, index) in list_sjfx_menu" :key="index" @click="toUrl(item.url)">
							<span :style="{color: menu2_sub_color[index], fontWeight: menu2_sub_fontWeight[index]}" @mouseenter="menu2SubEnter(index)">
								{{item.title}}
							</span>
						</div>
					</div>
				</el-col>
				<el-col :span="18">
					
					<div class="drop_menu_right" v-show="is_show_menu2_sub[0]">
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_sjfx_menu_0" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.sjfx[0]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu2_sub[1]">
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_sjfx_menu_1" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.sjfx[1]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu2_sub[2]">
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_sjfx_menu_2" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.sjfx[2]}}
						</div>
					</div>
					
				</el-col>
			</el-row>
		</div>
		
		<!-- 成长导航 -->
		<div class="drop_menu" v-show="is_show_menu[3]" @mouseleave="menuLeave(3)">
			<el-row>
				<el-col :span="6">
					<div class="drop_menu_left">
						<div class="drop_menu_left_title" v-for="(item, index) in list_czdh_menu" :key="index" @click="toUrl(item.url)">
							<span :style="{color: menu3_sub_color[index], fontWeight: menu3_sub_fontWeight[index]}" @mouseenter="menu3SubEnter(index)" @click="toUrl(item.url)">
								{{item.title}}
							</span>
						</div>
					</div>
				</el-col>
				<el-col :span="18">
					
					<div class="drop_menu_right" v-show="is_show_menu3_sub[0]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_czdh_menu_0" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.czdh[0]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu3_sub[1]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_czdh_menu_1" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.czdh[1]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu3_sub[2]">
						<!-- <div class="drop_menu_right_top">
							<el-input placeholder="请输入关键词搜索...">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div> -->
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_czdh_menu_2" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.czdh[2]}}
						</div>
					</div>
					
				</el-col>
			</el-row>
		</div>
		
		<!-- 知识产权 -->
		<div class="drop_menu" v-show="is_show_menu[4]" @mouseleave="menuLeave(4)">
			<el-row>
				<el-col :span="6">
					<div class="drop_menu_left">
						<div class="drop_menu_left_title" v-for="(item, index) in list_zscq_menu" :key="index" @click="toUrl(item.url)">
							<span :style="{color: menu4_sub_color[index], fontWeight: menu4_sub_fontWeight[index]}" @mouseenter="menu4SubEnter(index)" @click="toUrl(item.url)">
								{{item.title}}
							</span>
						</div>
					</div>
				</el-col>
				<el-col :span="18">
					
					<div class="drop_menu_right" v-show="is_show_menu4_sub[0]">
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_zscq_menu_0" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.zscq[0]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu4_sub[1]">
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_zscq_menu_1" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.zscq[1]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu4_sub[2]">
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_zscq_menu_2" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.zscq[2]}}
						</div>
					</div>
					
				</el-col>
			</el-row>
		</div>
		
		<!-- 风险管控 -->
		<div class="drop_menu" v-show="is_show_menu[5]" @mouseleave="menuLeave(5)">
			<el-row>
				<el-col :span="6">
					<div class="drop_menu_left">
						<div class="drop_menu_left_title" v-for="(item, index) in list_fxgk_menu" :key="index" @click="toUrl(item.url)">
							<span :style="{color: menu5_sub_color[index], fontWeight: menu5_sub_fontWeight[index]}" @mouseenter="menu5SubEnter(index)" @click="toUrl(item.url)">
								{{item.title}}
							</span>
						</div>
					</div>
				</el-col>
				<el-col :span="18">
					
					<div class="drop_menu_right" v-show="is_show_menu5_sub[0]">
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_fxgk_menu_0" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.fxgk[0]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu5_sub[1]">
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_fxgk_menu_1" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.fxgk[1]}}
						</div>
					</div>
					
					<div class="drop_menu_right" v-show="is_show_menu5_sub[2]">
						<div class="drop_menu_right_content">
							<el-row>
								<el-col :span="6" v-for="(item, index) in list_fxgk_menu_2" :key="index">
									<div class="drop_menu_right_content_text" @click="toUrl(item.url)">
										{{item.title}}
									</div>
								</el-col>
							</el-row>
						</div>
						<div class="drop_menu_right_bottom">
							{{detail_slogan.fxgk[2]}}
						</div>
					</div>
				
				</el-col>
			</el-row>
		</div>
		
		<div class="menu_mengban" v-show="is_show_mengban">
			
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				is_show_menu: [false, false, false, false, false, false],
				
				is_show_menu0_sub: [true, false, false, false, false, false, false, false, false, false, false, false, false, false],
				menu0_sub_color: ['#006ccb', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333'],
				menu0_sub_fontWeight: ['bold', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal'],
				
				is_show_menu1_sub: [true, false, false, false, false, false, false, false, false, false, false, false, false, false],
				menu1_sub_color: ['#006ccb', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333', '#333'],
				menu1_sub_fontWeight: ['bold', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal', 'normal'],
				
				is_show_menu2_sub: [true, false, false],
				menu2_sub_color: ['#006ccb', '#333', '#333'],
				menu2_sub_fontWeight: ['bold', 'normal', 'normal'],
				
				is_show_menu3_sub: [true, false, false],
				menu3_sub_color: ['#006ccb', '#333', '#333'],
				menu3_sub_fontWeight: ['bold', 'normal', 'normal'],
				
				is_show_menu4_sub: [true, false, false],
				menu4_sub_color: ['#006ccb', '#333', '#333'],
				menu4_sub_fontWeight: ['bold', 'normal', 'normal'],
				
				is_show_menu5_sub: [true, false, false],
				menu5_sub_color: ['#006ccb', '#333', '#333'],
				menu5_sub_fontWeight: ['bold', 'normal', 'normal'],
				
				list_bgqy_menu: [],
				list_bgqy_menu_0: [],
				list_bgqy_menu_1: [],
				list_bgqy_menu_2: [],
				list_bgqy_menu_3: [],
				list_bgqy_menu_4: [],
				list_bgqy_menu_5: [],
				list_bgqy_menu_6: [],
				list_bgqy_menu_7: [],
				list_bgqy_menu_8: [],
				list_bgqy_menu_9: [],
				list_bgqy_menu_10: [],
				list_bgqy_menu_11: [],
				list_bgqy_menu_12: [],
				list_bgqy_menu_13: [],
				
				list_wxdf_menu: [],
				list_wxdf_menu_0: [],
				list_wxdf_menu_1: [],
				list_wxdf_menu_2: [],
				list_wxdf_menu_3: [],
				list_wxdf_menu_4: [],
				list_wxdf_menu_5: [],
				list_wxdf_menu_6: [],
				list_wxdf_menu_7: [],
				list_wxdf_menu_8: [],
				list_wxdf_menu_9: [],
				list_wxdf_menu_10: [],
				list_wxdf_menu_11: [],
				list_wxdf_menu_12: [],
				list_wxdf_menu_13: [],
				
				list_sjfx_menu: [],
				list_sjfx_menu_0: [],
				list_sjfx_menu_1: [],
				list_sjfx_menu_2: [],
				
				list_czdh_menu: [],
				list_czdh_menu_0: [],
				list_czdh_menu_1: [],
				list_czdh_menu_2: [],
				
				list_zscq_menu: [],
				list_zscq_menu_0: [],
				list_zscq_menu_1: [],
				list_zscq_menu_2: [],
				
				list_fxgk_menu: [],
				list_fxgk_menu_0: [],
				list_fxgk_menu_1: [],
				list_fxgk_menu_2: [],
				
				detail_slogan: {"bgqy": ["","","","","","","","","","","","","",""],"wxdf": ["","","","","","","","","","","","","",""],"sjfx": ["","",""],"czdh": ["","",""],"zscq": ["","",""],"fxgk": ["","",""]},
				
				detail_logo: {'title': '', 'icon': '', 'summary': ''},
				
				is_show_mengban: false,
				
				is_login: false,
				
				menu_node_class: ['menu_node_cur', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node'],
				
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.loadMenu('10014', 'list_bgqy_menu')
			this.loadMenu('10017', 'list_bgqy_menu_0')
			this.loadMenu('10018', 'list_bgqy_menu_1')
			this.loadMenu('10019', 'list_bgqy_menu_2')
			this.loadMenu('10020', 'list_bgqy_menu_3')
			this.loadMenu('10021', 'list_bgqy_menu_4')
			this.loadMenu('10022', 'list_bgqy_menu_5')
			this.loadMenu('10023', 'list_bgqy_menu_6')
			this.loadMenu('10024', 'list_bgqy_menu_7')
			this.loadMenu('10025', 'list_bgqy_menu_8')
			this.loadMenu('10026', 'list_bgqy_menu_9')
			this.loadMenu('10027', 'list_bgqy_menu_10')
			this.loadMenu('10028', 'list_bgqy_menu_11')
			// this.loadMenu('10015', 'list_bgqy_menu_0')
			// this.loadMenu('10016', 'list_bgqy_menu_1')
			// this.loadMenu('10017', 'list_bgqy_menu_2')
			// this.loadMenu('10018', 'list_bgqy_menu_3')
			// this.loadMenu('10019', 'list_bgqy_menu_4')
			// this.loadMenu('10020', 'list_bgqy_menu_5')
			// this.loadMenu('10021', 'list_bgqy_menu_6')
			// this.loadMenu('10022', 'list_bgqy_menu_7')
			// this.loadMenu('10023', 'list_bgqy_menu_8')
			// this.loadMenu('10024', 'list_bgqy_menu_9')
			// this.loadMenu('10025', 'list_bgqy_menu_10')
			// this.loadMenu('10026', 'list_bgqy_menu_11')
			// this.loadMenu('10027', 'list_bgqy_menu_12')
			// this.loadMenu('10028', 'list_bgqy_menu_13')
			
			this.loadMenu('10032', 'list_wxdf_menu')
			this.loadMenu('10033', 'list_wxdf_menu_0')
			this.loadMenu('10034', 'list_wxdf_menu_1')
			this.loadMenu('10035', 'list_wxdf_menu_2')
			this.loadMenu('10036', 'list_wxdf_menu_3')
			this.loadMenu('10037', 'list_wxdf_menu_4')
			this.loadMenu('10038', 'list_wxdf_menu_5')
			this.loadMenu('10039', 'list_wxdf_menu_6')
			this.loadMenu('10040', 'list_wxdf_menu_7')
			this.loadMenu('10041', 'list_wxdf_menu_8')
			this.loadMenu('10042', 'list_wxdf_menu_9')
			this.loadMenu('10043', 'list_wxdf_menu_10')
			this.loadMenu('10044', 'list_wxdf_menu_11')
			this.loadMenu('10045', 'list_wxdf_menu_12')
			this.loadMenu('10046', 'list_wxdf_menu_13')
			
			this.loadMenu('10050', 'list_sjfx_menu')
			this.loadMenu('10051', 'list_sjfx_menu_0')
			this.loadMenu('10052', 'list_sjfx_menu_1')
			this.loadMenu('10053', 'list_sjfx_menu_2')
			
			this.loadMenu('10056', 'list_czdh_menu')
			this.loadMenu('10057', 'list_czdh_menu_0')
			this.loadMenu('10058', 'list_czdh_menu_1')
			this.loadMenu('10059', 'list_czdh_menu_2')
			
			this.loadMenu('10062', 'list_zscq_menu')
			this.loadMenu('10063', 'list_zscq_menu_0')
			this.loadMenu('10064', 'list_zscq_menu_1')
			this.loadMenu('10065', 'list_zscq_menu_2')
			
			this.loadMenu('10068', 'list_fxgk_menu')
			this.loadMenu('10069', 'list_fxgk_menu_0')
			this.loadMenu('10070', 'list_fxgk_menu_1')
			this.loadMenu('10071', 'list_fxgk_menu_2')
			
			this.loadMenu('10074', 'detail_slogan')
			
			this.loadMenu('10088', 'detail_logo')
			
			this.checkLogin()
			
			this.handleMenuCur()
		},
		
		methods: {
			// 鼠标离开整个页面区域
			headerMouseLeave(index) {
				var event = event || window.event;
				var posX = event.pageX, posY = event.pageY;
				// console.log(posY);
				if (posY > 60 && posY < 660) {
					// console.log('鼠标离开整个页面区域--》不隐藏悬浮菜单')
					this.focusMenuLeave() // 如果显示悬浮菜单则注释改行代码，如果不显示则放开，1/2
				} else {
					// console.log('鼠标离开整个页面区域--》跳过处理逻辑')
					this.is_show_mengban = false
					for (let i=0; i<this.is_show_menu.length; i++) {
						this.$set(this.is_show_menu, i, false)
					}
					this.focusMenuLeave()
				}
				
			},
			
			// 鼠标进入到菜单区域
			menuEnter(index) {
				// console.log(index)
				// console.log(this.is_show_menu)
				let hidMenuFlag = sessionStorage.getItem('hidMenuFlag') // 跟toUrl中的特殊设置有关联 sessionStorage.setItem('hidMenuFlag', 1)
				if (hidMenuFlag == 1) {
					// 过1秒后，再将隐藏标记去掉 （备注：本身还想做其它业务处理进行控制，但莫名其妙实现了效果）
					setTimeout(() => {
						sessionStorage.setItem('hidMenuFlag', '0')
					}, 1000)
				} else {
					// 如果显示悬浮菜单则将下列注释放开，如果不显示则注释掉，2/2
					// for (let i=0; i<this.is_show_menu.length; i++) {
					// 	if (i == index) {
					// 		this.$set(this.is_show_menu, i, true) // 给数组赋值，通过this.$set可以更新数组后双向绑定view，如果直接this.array[i]进行赋值不产生双向绑定
					// 	} else {
					// 		this.$set(this.is_show_menu, i, false)
					// 	}
					// }
					// this.is_show_mengban = true // 同时展现蒙板效果
				}
				
				this.focusMenuEnter(index)
				
			},
			
			// 鼠标离开菜单展开区域
			menuLeave(index) {
				console.log(index)
				var event = event || window.event;
				var posX = event.pageX, posY = event.pageY;
				// console.log(posY);
				if (posY > 60 && posY < 660) {
					console.log('鼠标离开菜单展开区域--》不隐藏悬浮菜单')
					this.focusMenuEnter(index)
				} else {
					console.log('鼠标离开菜单展开区域--》跳过处理逻辑')
					this.is_show_mengban = false
					for (let i=0; i<this.is_show_menu.length; i++) {
						this.$set(this.is_show_menu, i, false)
					}
				}
				
			},
			
			// menu0子菜单，鼠标进入触发
			menu0SubEnter(index) {
				for (let i=0; i<this.is_show_menu0_sub.length; i++) {
					if (i == index) {
						this.$set(this.is_show_menu0_sub, i, true)
						this.$set(this.menu0_sub_color, i, '#006ccb')
						this.$set(this.menu0_sub_fontWeight, i, 'bold')
					} else {
						this.$set(this.is_show_menu0_sub, i, false)
						this.$set(this.menu0_sub_color, i, '#333')
						this.$set(this.menu0_sub_fontWeight, i, 'normal')
					}
				}
			},
			
			// menu1子菜单，鼠标进入触发
			menu1SubEnter(index) {
				// console.log(index)
				for (let i=0; i<this.is_show_menu1_sub.length; i++) {
					if (i == index) {
						this.$set(this.is_show_menu1_sub, i, true)
						this.$set(this.menu1_sub_color, i, '#006ccb')
						this.$set(this.menu1_sub_fontWeight, i, 'bold')
					} else {
						this.$set(this.is_show_menu1_sub, i, false)
						this.$set(this.menu1_sub_color, i, '#333')
						this.$set(this.menu1_sub_fontWeight, i, 'normal')
					}
				}
			},
			
			// menu2子菜单，鼠标进入触发
			menu2SubEnter(index) {
				// console.log(index)
				for (let i=0; i<this.is_show_menu2_sub.length; i++) {
					if (i == index) {
						this.$set(this.is_show_menu2_sub, i, true)
						this.$set(this.menu2_sub_color, i, '#006ccb')
						this.$set(this.menu2_sub_fontWeight, i, 'bold')
					} else {
						this.$set(this.is_show_menu2_sub, i, false)
						this.$set(this.menu2_sub_color, i, '#333')
						this.$set(this.menu2_sub_fontWeight, i, 'normal')
					}
				}
			},
			
			// menu3子菜单，鼠标进入触发
			menu3SubEnter(index) {
				// console.log(index)
				for (let i=0; i<this.is_show_menu3_sub.length; i++) {
					if (i == index) {
						this.$set(this.is_show_menu3_sub, i, true)
						this.$set(this.menu3_sub_color, i, '#006ccb')
						this.$set(this.menu3_sub_fontWeight, i, 'bold')
					} else {
						this.$set(this.is_show_menu3_sub, i, false)
						this.$set(this.menu3_sub_color, i, '#333')
						this.$set(this.menu3_sub_fontWeight, i, 'normal')
					}
				}
			},
			
			// menu4子菜单，鼠标进入触发
			menu4SubEnter(index) {
				// console.log(index)
				for (let i=0; i<this.is_show_menu4_sub.length; i++) {
					if (i == index) {
						this.$set(this.is_show_menu4_sub, i, true)
						this.$set(this.menu4_sub_color, i, '#006ccb')
						this.$set(this.menu4_sub_fontWeight, i, 'bold')
					} else {
						this.$set(this.is_show_menu4_sub, i, false)
						this.$set(this.menu4_sub_color, i, '#333')
						this.$set(this.menu4_sub_fontWeight, i, 'normal')
					}
				}
			},
			
			// menu5子菜单，鼠标进入触发
			menu5SubEnter(index) {
				// console.log(index)
				for (let i=0; i<this.is_show_menu5_sub.length; i++) {
					if (i == index) {
						this.$set(this.is_show_menu5_sub, i, true)
						this.$set(this.menu5_sub_color, i, '#006ccb')
						this.$set(this.menu5_sub_fontWeight, i, 'bold')
					} else {
						this.$set(this.is_show_menu5_sub, i, false)
						this.$set(this.menu5_sub_color, i, '#333')
						this.$set(this.menu5_sub_fontWeight, i, 'normal')
					}
				}
			},
			
			// 加载菜单下配置数据
			loadMenu(config_id, return_obj) {
				let url = this.$common.apiUrl + 'pub_web_config/detail/' + config_id
				this.$axios.get(url).then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					if (return_obj == 'list_bgqy_menu') {
						this.list_bgqy_menu = list
					} else if (return_obj == 'list_bgqy_menu_0'){
						this.list_bgqy_menu_0 = list
					} else if (return_obj == 'list_bgqy_menu_1'){
						this.list_bgqy_menu_1 = list
					} else if (return_obj == 'list_bgqy_menu_2'){
						this.list_bgqy_menu_2 = list
					} else if (return_obj == 'list_bgqy_menu_3'){
						this.list_bgqy_menu_3 = list
					} else if (return_obj == 'list_bgqy_menu_4'){
						this.list_bgqy_menu_4 = list
					} else if (return_obj == 'list_bgqy_menu_5'){
						this.list_bgqy_menu_5 = list
					} else if (return_obj == 'list_bgqy_menu_6'){
						this.list_bgqy_menu_6 = list
					} else if (return_obj == 'list_bgqy_menu_7'){
						this.list_bgqy_menu_7 = list
					} else if (return_obj == 'list_bgqy_menu_8'){
						this.list_bgqy_menu_8 = list
					} else if (return_obj == 'list_bgqy_menu_9'){
						this.list_bgqy_menu_9 = list
					} else if (return_obj == 'list_bgqy_menu_10'){
						this.list_bgqy_menu_10 = list
					} else if (return_obj == 'list_bgqy_menu_11'){
						this.list_bgqy_menu_11 = list
					} else if (return_obj == 'list_bgqy_menu_12'){
						this.list_bgqy_menu_12 = list
					} else if (return_obj == 'list_bgqy_menu_13'){
						this.list_bgqy_menu_13 = list
					}
					
					else if (return_obj == 'list_wxdf_menu'){
						this.list_wxdf_menu = list
					} else if (return_obj == 'list_wxdf_menu_0'){
						this.list_wxdf_menu_0 = list
					} else if (return_obj == 'list_wxdf_menu_1'){
						this.list_wxdf_menu_1 = list
					} else if (return_obj == 'list_wxdf_menu_2'){
						this.list_wxdf_menu_2 = list
					} else if (return_obj == 'list_wxdf_menu_3'){
						this.list_wxdf_menu_3 = list
					} else if (return_obj == 'list_wxdf_menu_4'){
						this.list_wxdf_menu_4 = list
					} else if (return_obj == 'list_wxdf_menu_5'){
						this.list_wxdf_menu_5 = list
					} else if (return_obj == 'list_wxdf_menu_6'){
						this.list_wxdf_menu_6 = list
					} else if (return_obj == 'list_wxdf_menu_7'){
						this.list_wxdf_menu_7 = list
					} else if (return_obj == 'list_wxdf_menu_8'){
						this.list_wxdf_menu_8 = list
					} else if (return_obj == 'list_wxdf_menu_9'){
						this.list_wxdf_menu_9 = list
					} else if (return_obj == 'list_wxdf_menu_10'){
						this.list_wxdf_menu_10 = list
					} else if (return_obj == 'list_wxdf_menu_11'){
						this.list_wxdf_menu_11 = list
					} else if (return_obj == 'list_wxdf_menu_12'){
						this.list_wxdf_menu_12 = list
						console.log('list_wxdf_menu_12', this.list_wxdf_menu_12)
					} else if (return_obj == 'list_wxdf_menu_13'){
						this.list_wxdf_menu_13 = list
					}
					
					else if (return_obj == 'list_sjfx_menu'){
						this.list_sjfx_menu = list
					} else if (return_obj == 'list_sjfx_menu_0'){
						this.list_sjfx_menu_0 = list
					} else if (return_obj == 'list_sjfx_menu_1'){
						this.list_sjfx_menu_1 = list
					} else if (return_obj == 'list_sjfx_menu_2'){
						this.list_sjfx_menu_2 = list
					}
					
					else if (return_obj == 'list_czdh_menu'){
						this.list_czdh_menu = list
					} else if (return_obj == 'list_czdh_menu_0'){
						this.list_czdh_menu_0 = list
					} else if (return_obj == 'list_czdh_menu_1'){
						this.list_czdh_menu_1 = list
					} else if (return_obj == 'list_czdh_menu_2'){
						this.list_czdh_menu_2 = list
					}
					
					else if (return_obj == 'list_zscq_menu'){
						this.list_zscq_menu = list
					} else if (return_obj == 'list_zscq_menu_0'){
						this.list_zscq_menu_0 = list
					} else if (return_obj == 'list_zscq_menu_1'){
						this.list_zscq_menu_1 = list
					} else if (return_obj == 'list_zscq_menu_2'){
						this.list_zscq_menu_2 = list
					}
					
					else if (return_obj == 'list_fxgk_menu'){
						this.list_fxgk_menu = list
					} else if (return_obj == 'list_fxgk_menu_0'){
						this.list_fxgk_menu_0 = list
					} else if (return_obj == 'list_fxgk_menu_1'){
						this.list_fxgk_menu_1 = list
					} else if (return_obj == 'list_fxgk_menu_2'){
						this.list_fxgk_menu_2 = list
					}
					
					else if (return_obj == 'detail_slogan') {
						this.detail_slogan = list
						// console.log(this.detail_slogan)
					}
					
					else if (return_obj == 'detail_logo') {
						this.detail_logo = list[0]
						this.detail_logo.icon = this.$common.adimgUrl + this.detail_logo.icon
						// console.log(this.detail_logo)
					}
					
					
				})
			},
			
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
				// 特殊情况，菜单区域点击后关闭悬浮页面，这里功能不太完善，后续再处理
				this.is_show_mengban = false
				sessionStorage.setItem('hidMenuFlag', 1)
				for (let i=0; i<this.is_show_menu.length; i++) {
					this.$set(this.is_show_menu, i, false) // 所有菜单隐藏
				}
			},
			
			// 检查是否已登录
			checkLogin() {
				let cur_user = localStorage.getItem('cur_user')
				// console.log(cur_user=='null')
				if (cur_user!=null) {
					// console.log('已登录')
					this.is_login = true;
				} else {
					// console.log('未登录')
					this.is_login = false;
				}
			},
			
			// 退出
			doExit() {
				localStorage.clear()
				// this.$router.go(0)
				location.href = '/'
			},
			
			// 处理当前页面默认显示，深色显示
			handleMenuCur() {
				let url = window.location.href;
				// console.log('当前页面URL：' + url);
				if (url.indexOf('index') > -1) {
					this.menu_node_class = ['menu_node_cur', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node']
					let a = this.$refs.menuref9
					a.style.color = '#055bcc';
					a.style.borderBottom = '2px solid #055bcc';
					a.style.fontWeight = 'bold';
					// console.log(a)
				} else if (url.indexOf('list_biaogan') > -1 || url.indexOf('detail_company') > -1) {
					this.menu_node_class = ['menu_node', 'menu_node_cur', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node']
					let a = this.$refs.menuref0
					a.style.color = '#055bcc';
					a.style.borderBottom = '2px solid #055bcc';
					a.style.fontWeight = 'bold';
				} else if (url.indexOf('list_wenda') > -1 || url.indexOf('detail_wenda') > -1) {
					this.menu_node_class = ['menu_node', 'menu_node', 'menu_node_cur', 'menu_node', 'menu_node', 'menu_node', 'menu_node']
					let a = this.$refs.menuref1
					a.style.color = '#055bcc';
					a.style.borderBottom = '2px solid #055bcc';
					a.style.fontWeight = 'bold';
				} else if (url.indexOf('statis') > -1) {
					this.menu_node_class = ['menu_node', 'menu_node', 'menu_node', 'menu_node_cur', 'menu_node', 'menu_node', 'menu_node']
					let a = this.$refs.menuref2
					a.style.color = '#055bcc';
					a.style.borderBottom = '2px solid #055bcc';
					a.style.fontWeight = 'bold';
				} else if (url.indexOf('daohang') > -1) {
					this.menu_node_class = ['menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node_cur', 'menu_node', 'menu_node']
					let a = this.$refs.menuref3
					a.style.color = '#055bcc';
					a.style.borderBottom = '2px solid #055bcc';
					a.style.fontWeight = 'bold';
				} else if (url.indexOf('zhichan') > -1) {
					this.menu_node_class = ['menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node_cur', 'menu_node']
					let a = this.$refs.menuref4
					a.style.color = '#055bcc';
					a.style.borderBottom = '2px solid #055bcc';
					a.style.fontWeight = 'bold';
				} else if (url.indexOf('fengxian') > -1) {
					this.menu_node_class = ['menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node_cur']
					let a = this.$refs.menuref5
					a.style.color = '#055bcc';
					a.style.borderBottom = '2px solid #055bcc';
					a.style.fontWeight = 'bold';
				} else {
					this.menu_node_class = ['menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node', 'menu_node']
				}
				
			},
			
			// 当前获取焦点的菜单浅色显示
			focusMenuEnter(index) {
				let a, b, c, d, e, f, g;
				if (index == 0) {
					a = this.$refs.menuref0
					b = this.$refs.menuref1
					c = this.$refs.menuref2
					d = this.$refs.menuref3
					e = this.$refs.menuref4
					f = this.$refs.menuref5
					g = this.$refs.menuref9
				} else if (index == 1) {
					a = this.$refs.menuref1
					b = this.$refs.menuref0
					c = this.$refs.menuref2
					d = this.$refs.menuref3
					e = this.$refs.menuref4
					f = this.$refs.menuref5
					g = this.$refs.menuref9
				} else if (index == 2) {
					a = this.$refs.menuref2
					b = this.$refs.menuref0
					c = this.$refs.menuref1
					d = this.$refs.menuref3
					e = this.$refs.menuref4
					f = this.$refs.menuref5
					g = this.$refs.menuref9
				} else if (index == 3) {
					a = this.$refs.menuref3
					b = this.$refs.menuref0
					c = this.$refs.menuref1
					d = this.$refs.menuref2
					e = this.$refs.menuref4
					f = this.$refs.menuref5
					g = this.$refs.menuref9
				} else if (index == 4) {
					a = this.$refs.menuref4
					b = this.$refs.menuref0
					c = this.$refs.menuref1
					d = this.$refs.menuref2
					e = this.$refs.menuref3
					f = this.$refs.menuref5
					g = this.$refs.menuref9
				} else if (index == 5) {
					a = this.$refs.menuref5
					b = this.$refs.menuref0
					c = this.$refs.menuref1
					d = this.$refs.menuref2
					e = this.$refs.menuref3
					f = this.$refs.menuref4
					g = this.$refs.menuref9
				} else {
					a = this.$refs.menuref9
					b = this.$refs.menuref0
					c = this.$refs.menuref1
					d = this.$refs.menuref2
					e = this.$refs.menuref3
					f = this.$refs.menuref4
					g = this.$refs.menuref5
				}
				a.style.color = '#0099dd';
				a.style.borderBottom = '2px solid #0099dd';
				a.style.fontWeight = 'bold';
				b.style.color = '#333';
				b.style.borderBottom = '2px solid #fff';
				b.style.fontWeight = 'normal';
				c.style.color = '#333';
				c.style.borderBottom = '2px solid #fff';
				c.style.fontWeight = 'normal';
				d.style.color = '#333';
				d.style.borderBottom = '2px solid #fff';
				d.style.fontWeight = 'normal';
				e.style.color = '#333';
				e.style.borderBottom = '2px solid #fff';
				e.style.fontWeight = 'normal';
				f.style.color = '#333';
				f.style.borderBottom = '2px solid #fff';
				f.style.fontWeight = 'normal';
				g.style.color = '#333';
				g.style.borderBottom = '2px solid #fff';
				g.style.fontWeight = 'normal';
				this.handleMenuCur()
			},
			
			// 菜单失去焦点时
			focusMenuLeave() {
				let url = window.location.href;
				console.log('当前页面URL（菜单失去焦点时）：' + url);
				if (url.indexOf('index') > -1) {
					this.$refs.menuref0.style.color = '#333';
					this.$refs.menuref0.style.borderBottom = '2px solid #fff';
					this.$refs.menuref0.style.fontWeight = 'normal';
					this.$refs.menuref1.style.color = '#333';
					this.$refs.menuref1.style.borderBottom = '2px solid #fff';
					this.$refs.menuref1.style.fontWeight = 'normal';
					this.$refs.menuref2.style.color = '#333';
					this.$refs.menuref2.style.borderBottom = '2px solid #fff';
					this.$refs.menuref2.style.fontWeight = 'normal';
					this.$refs.menuref3.style.color = '#333';
					this.$refs.menuref3.style.borderBottom = '2px solid #fff';
					this.$refs.menuref3.style.fontWeight = 'normal';
					this.$refs.menuref4.style.color = '#333';
					this.$refs.menuref4.style.borderBottom = '2px solid #fff';
					this.$refs.menuref4.style.fontWeight = 'normal';
					this.$refs.menuref5.style.color = '#333';
					this.$refs.menuref5.style.borderBottom = '2px solid #fff';
					this.$refs.menuref5.style.fontWeight = 'normal';
				} else if (url.indexOf('list_biaogan') > -1 || url.indexOf('detail_company') > -1) {
					this.$refs.menuref9.style.color = '#333';
					this.$refs.menuref9.style.borderBottom = '2px solid #fff';
					this.$refs.menuref9.style.fontWeight = 'normal';
					this.$refs.menuref1.style.color = '#333';
					this.$refs.menuref1.style.borderBottom = '2px solid #fff';
					this.$refs.menuref1.style.fontWeight = 'normal';
					this.$refs.menuref2.style.color = '#333';
					this.$refs.menuref2.style.borderBottom = '2px solid #fff';
					this.$refs.menuref2.style.fontWeight = 'normal';
					this.$refs.menuref3.style.color = '#333';
					this.$refs.menuref3.style.borderBottom = '2px solid #fff';
					this.$refs.menuref3.style.fontWeight = 'normal';
					this.$refs.menuref4.style.color = '#333';
					this.$refs.menuref4.style.borderBottom = '2px solid #fff';
					this.$refs.menuref4.style.fontWeight = 'normal';
					this.$refs.menuref5.style.color = '#333';
					this.$refs.menuref5.style.borderBottom = '2px solid #fff';
					this.$refs.menuref5.style.fontWeight = 'normal';
				} else if (url.indexOf('list_wenda') > -1 || url.indexOf('detail_wenda') > -1) {
					this.$refs.menuref0.style.color = '#333';
					this.$refs.menuref0.style.borderBottom = '2px solid #fff';
					this.$refs.menuref0.style.fontWeight = 'normal';
					this.$refs.menuref9.style.color = '#333';
					this.$refs.menuref9.style.borderBottom = '2px solid #fff';
					this.$refs.menuref9.style.fontWeight = 'normal';
					this.$refs.menuref2.style.color = '#333';
					this.$refs.menuref2.style.borderBottom = '2px solid #fff';
					this.$refs.menuref2.style.fontWeight = 'normal';
					this.$refs.menuref3.style.color = '#333';
					this.$refs.menuref3.style.borderBottom = '2px solid #fff';
					this.$refs.menuref3.style.fontWeight = 'normal';
					this.$refs.menuref4.style.color = '#333';
					this.$refs.menuref4.style.borderBottom = '2px solid #fff';
					this.$refs.menuref4.style.fontWeight = 'normal';
					this.$refs.menuref5.style.color = '#333';
					this.$refs.menuref5.style.borderBottom = '2px solid #fff';
					this.$refs.menuref5.style.fontWeight = 'normal';
				} else if (url.indexOf('statis') > -1) {
					this.$refs.menuref0.style.color = '#333';
					this.$refs.menuref0.style.borderBottom = '2px solid #fff';
					this.$refs.menuref0.style.fontWeight = 'normal';
					this.$refs.menuref1.style.color = '#333';
					this.$refs.menuref1.style.borderBottom = '2px solid #fff';
					this.$refs.menuref1.style.fontWeight = 'normal';
					this.$refs.menuref9.style.color = '#333';
					this.$refs.menuref9.style.borderBottom = '2px solid #fff';
					this.$refs.menuref9.style.fontWeight = 'normal';
					this.$refs.menuref3.style.color = '#333';
					this.$refs.menuref3.style.borderBottom = '2px solid #fff';
					this.$refs.menuref3.style.fontWeight = 'normal';
					this.$refs.menuref4.style.color = '#333';
					this.$refs.menuref4.style.borderBottom = '2px solid #fff';
					this.$refs.menuref4.style.fontWeight = 'normal';
					this.$refs.menuref5.style.color = '#333';
					this.$refs.menuref5.style.borderBottom = '2px solid #fff';
					this.$refs.menuref5.style.fontWeight = 'normal';
				} else if (url.indexOf('daohang') > -1) {
					this.$refs.menuref0.style.color = '#333';
					this.$refs.menuref0.style.borderBottom = '2px solid #fff';
					this.$refs.menuref0.style.fontWeight = 'normal';
					this.$refs.menuref1.style.color = '#333';
					this.$refs.menuref1.style.borderBottom = '2px solid #fff';
					this.$refs.menuref1.style.fontWeight = 'normal';
					this.$refs.menuref2.style.color = '#333';
					this.$refs.menuref2.style.borderBottom = '2px solid #fff';
					this.$refs.menuref2.style.fontWeight = 'normal';
					this.$refs.menuref9.style.color = '#333';
					this.$refs.menuref9.style.borderBottom = '2px solid #fff';
					this.$refs.menuref9.style.fontWeight = 'normal';
					this.$refs.menuref4.style.color = '#333';
					this.$refs.menuref4.style.borderBottom = '2px solid #fff';
					this.$refs.menuref4.style.fontWeight = 'normal';
					this.$refs.menuref5.style.color = '#333';
					this.$refs.menuref5.style.borderBottom = '2px solid #fff';
					this.$refs.menuref5.style.fontWeight = 'normal';
				} else if (url.indexOf('zhichan') > -1) {
					this.$refs.menuref0.style.color = '#333';
					this.$refs.menuref0.style.borderBottom = '2px solid #fff';
					this.$refs.menuref0.style.fontWeight = 'normal';
					this.$refs.menuref1.style.color = '#333';
					this.$refs.menuref1.style.borderBottom = '2px solid #fff';
					this.$refs.menuref1.style.fontWeight = 'normal';
					this.$refs.menuref2.style.color = '#333';
					this.$refs.menuref2.style.borderBottom = '2px solid #fff';
					this.$refs.menuref2.style.fontWeight = 'normal';
					this.$refs.menuref3.style.color = '#333';
					this.$refs.menuref3.style.borderBottom = '2px solid #fff';
					this.$refs.menuref3.style.fontWeight = 'normal';
					this.$refs.menuref9.style.color = '#333';
					this.$refs.menuref9.style.borderBottom = '2px solid #fff';
					this.$refs.menuref9.style.fontWeight = 'normal';
					this.$refs.menuref5.style.color = '#333';
					this.$refs.menuref5.style.borderBottom = '2px solid #fff';
					this.$refs.menuref5.style.fontWeight = 'normal';
				} else if (url.indexOf('fengxian') > -1) {
					this.$refs.menuref0.style.color = '#333';
					this.$refs.menuref0.style.borderBottom = '2px solid #fff';
					this.$refs.menuref0.style.fontWeight = 'normal';
					this.$refs.menuref1.style.color = '#333';
					this.$refs.menuref1.style.borderBottom = '2px solid #fff';
					this.$refs.menuref1.style.fontWeight = 'normal';
					this.$refs.menuref2.style.color = '#333';
					this.$refs.menuref2.style.borderBottom = '2px solid #fff';
					this.$refs.menuref2.style.fontWeight = 'normal';
					this.$refs.menuref3.style.color = '#333';
					this.$refs.menuref3.style.borderBottom = '2px solid #fff';
					this.$refs.menuref3.style.fontWeight = 'normal';
					this.$refs.menuref4.style.color = '#333';
					this.$refs.menuref4.style.borderBottom = '2px solid #fff';
					this.$refs.menuref4.style.fontWeight = 'normal';
					this.$refs.menuref9.style.color = '#333';
					this.$refs.menuref9.style.borderBottom = '2px solid #fff';
					this.$refs.menuref9.style.fontWeight = 'normal';
				} else {
					this.$refs.menuref0.style.color = '#333';
					this.$refs.menuref0.style.borderBottom = '2px solid #fff';
					this.$refs.menuref0.style.fontWeight = 'normal';
					this.$refs.menuref1.style.color = '#333';
					this.$refs.menuref1.style.borderBottom = '2px solid #fff';
					this.$refs.menuref1.style.fontWeight = 'normal';
					this.$refs.menuref2.style.color = '#333';
					this.$refs.menuref2.style.borderBottom = '2px solid #fff';
					this.$refs.menuref2.style.fontWeight = 'normal';
					this.$refs.menuref3.style.color = '#333';
					this.$refs.menuref3.style.borderBottom = '2px solid #fff';
					this.$refs.menuref3.style.fontWeight = 'normal';
					this.$refs.menuref4.style.color = '#333';
					this.$refs.menuref4.style.borderBottom = '2px solid #fff';
					this.$refs.menuref4.style.fontWeight = 'normal';
					this.$refs.menuref5.style.color = '#333';
					this.$refs.menuref5.style.borderBottom = '2px solid #fff';
					this.$refs.menuref5.style.fontWeight = 'normal';
					this.$refs.menuref9.style.color = '#333';
					this.$refs.menuref9.style.borderBottom = '2px solid #fff';
					this.$refs.menuref9.style.fontWeight = 'normal';
				}
			},
			
			
		}
	}
</script>

<style>
</style>